"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldTimeData = void 0;
const helpers_1 = require("../../../helpers");
const getFieldTimeData = (scheduleValue) => {
    const times = helpers_1.getTimes();
    const timeLocal = scheduleValue.reduce((acc, curr, idx) => {
        if (curr) {
            acc.push(times[idx]);
        }
        return acc;
    }, []);
    if (!timeLocal.length) {
        return times;
    }
    return timeLocal;
};
exports.getFieldTimeData = getFieldTimeData;
//# sourceMappingURL=getFieldTimeData.js.map